namespace InvData {

    export class ModelEnvironment {

        public entityIdToEntityMap: any;
        public entityList: any;
        public investmentIdToInvestmentMap: any;
        public investmentList: any;
        public resourceIdToResourceMap: any;
        public ownerIdToInvestmentLookup: any;
        public holdingIdToInvestmentLookup: any;
        public currencies: InvData.Models.IdAndCodeObjectIndex<any>;
        public currencyPairs: InvData.Models.IdAndCodeObjectIndex<any>;
        public tagSets: InvData.Models.IdAndCodeObjectIndex<InvData.Models.TagSet>;
        public exposureProfiles: InvData.Models.IdAndCodeObjectIndex<any>;
        public propertyDefinitions: InvData.Models.IdAndCodeObjectIndex<PropertyDefinition>;
        public labelHelper: ModelEnvironmentLabelHelper;
        public users: InvData.Models.IdAndCodeObjectIndex<User>;
        public managerIdToManagerMap: { [id: number]: Manager };
        public managers: Manager[];

        constructor() {
            this.entityIdToEntityMap = {};
            this.entityList = [];

            this.investmentIdToInvestmentMap = {};
            this.investmentList = [];

            this.resourceIdToResourceMap = {};

            this.managerIdToManagerMap = {};
            this.managers = [];

            // investment lookup matches entity id to investments that link them.
            this.ownerIdToInvestmentLookup = {};
            this.holdingIdToInvestmentLookup = {};
            
            // Collections
            this.currencies = new InvData.Models.IdAndCodeObjectIndex();
            this.currencyPairs = new InvData.Models.IdAndCodeObjectIndex();
            this.tagSets = new InvData.Models.IdAndCodeObjectIndex<InvData.Models.TagSet>();
            this.exposureProfiles = new InvData.Models.IdAndCodeObjectIndex();
            this.propertyDefinitions = new InvData.Models.IdAndCodeObjectIndex<PropertyDefinition>();
            this.users = new InvData.Models.IdAndCodeObjectIndex<User>();

            // Always create helper for labels.
            this.labelHelper = new InvData.ModelEnvironmentLabelHelper(this);
        }


        public getEntityById(entityId) {
            if (this.entityIdToEntityMap[entityId])
                return this.entityIdToEntityMap[entityId];
            else
                return null;
        }

        public tryGetEntityByResourceId(resourceId) {
            var resource = this.getResourceById(resourceId);
            if (resource) {
                // We have to compare resourceId because entities and investments can have overlapping ids.
                var entity = this.getEntityById(resource.id);
                if (entity && entity.resourceId === resourceId) {
                    return entity;
                }
            }

            return null;
        }

        public getInvestmentById(investmentId) {
            if (this.investmentIdToInvestmentMap[investmentId])
                return this.investmentIdToInvestmentMap[investmentId];
            else
                return null;
      }

        public tryGetInvestmentByResourceId(resourceId) {
            var resource = this.getResourceById(resourceId);
            if (resource) {
                // We have to compare resourceId because entities and investments can have overlapping ids.
                var investment = this.getInvestmentById(resource.id);
                if (investment && investment.resourceId === resourceId) {
                    return investment;
                }
            }

            return null;
        }

        public getResourceById(resourceId) {
            if (this.resourceIdToResourceMap[resourceId])
                return this.resourceIdToResourceMap[resourceId];
            else
                return null;
        }

        public getInvestmentsForOwnerId(entityId) {
            var self = this;

            var resultList = [];
            if (this.ownerIdToInvestmentLookup[entityId]) {
                for (let investmentId of this.ownerIdToInvestmentLookup[entityId]) {                
                    var investment = self.getInvestmentById(investmentId);
                    if (investment) {
                        resultList.push(investment);
                    }
                }
            }

            return resultList;
        }

        public getInvestmentsForHoldingId(entityId) {
            var self = this;

            var resultList = [];
            if (this.holdingIdToInvestmentLookup[entityId]) {
                for (let investmentId of this.holdingIdToInvestmentLookup[entityId]) {
                    var investment = self.getInvestmentById(investmentId);
                    if (investment) {
                        resultList.push(investment);
                    }
                }
            }

            return resultList;
        }

      public getManagerById(managerId) {
        if (this.managerIdToManagerMap[managerId])
          return this.managerIdToManagerMap[managerId];
        else
          return null;
      }

        /**
         * doesEntityOwnOtherEntity returns true if entityId owns otherEntityId.
         * @param entityId
         * @param otherEntityId
         */
        public doesEntityOwnOtherEntity(entityId, otherEntityId) {           
            var self = this;

            var found = false;

            var resultList = [];
            if (this.ownerIdToInvestmentLookup[entityId]) {
                for (let investmentId of this.ownerIdToInvestmentLookup[entityId]) {
                    var investment = self.getInvestmentById(investmentId);
                    if (investment) {
                        if (investment.holdingId == otherEntityId) {
                            found = true;
                        }
                    }
                }
            }

            return found;
        }

        public mergeEnvironmentData(newModelEnvironment: InvData.Models.JsonModelEnvironment | InvData.ModelEnvironment): void {
            var self = this;

            if (!newModelEnvironment) {
                return;
            }

            if (newModelEnvironment instanceof InvData.ModelEnvironment) {
                // We are merging a model environment that has already been loaded into the Javascript class representation.

                if (newModelEnvironment.currencies && newModelEnvironment.currencies.itemList) {
                    for (let item of newModelEnvironment.currencies.itemList) {                    
                        self.currencies.addOrReplace(item);
                    }
                }

                if (newModelEnvironment.currencyPairs && newModelEnvironment.currencyPairs.itemList) {
                    for (let item of newModelEnvironment.currencyPairs.itemList) {                    
                        self.currencyPairs.addOrReplace(item);
                    }
                }

                if (newModelEnvironment.tagSets && newModelEnvironment.tagSets.itemList) {
                    for (let tagSet of newModelEnvironment.tagSets.itemList) {                    
                        self.tagSets.addOrReplace(tagSet);
                    }
                }

                if (newModelEnvironment.exposureProfiles && newModelEnvironment.exposureProfiles.itemList) {
                    for (let item of newModelEnvironment.exposureProfiles.itemList) {                    
                        self.exposureProfiles.addOrReplace(item);
                    }
                }

                if (newModelEnvironment.propertyDefinitions && newModelEnvironment.propertyDefinitions.itemList) {
                    for (let propDef of newModelEnvironment.propertyDefinitions.itemList) {                    
                        self.propertyDefinitions.addOrReplace(propDef);
                    }
                }


                if (newModelEnvironment.entityList) {
                    for (let newEntity of newModelEnvironment.entityList) {                    
                        self._addEntity(newEntity);
                    }
                }

                if (newModelEnvironment.investmentList) {
                    for (let newInvestment of newModelEnvironment.investmentList) {                    
                        self._addInvestment(newInvestment);
                    }
                }

                if(newModelEnvironment.users) {
                    for(let userData of newModelEnvironment.users.itemList) {
                        self.users.addOrReplace(userData);
                    }
                }

                if (newModelEnvironment.managers) {
                  for (let newManager of newModelEnvironment.managers) {
                    self._addManager(newManager);
                  }
                }
            }
            else {
                // We are merging a plain JSON representation.

                if (newModelEnvironment.currencies) {
                    for (let item of newModelEnvironment.currencies) {                    
                        self.currencies.addOrReplace(item);
                    }
                }

                if (newModelEnvironment.currencyPairs) {
                    for (let item of newModelEnvironment.currencyPairs) {                    
                        self.currencyPairs.addOrReplace(item);
                    }
                }

                if (newModelEnvironment.tagSets) {
                    for (let tagSetData of newModelEnvironment.tagSets) {
                        var tagSet = new InvData.Models.TagSet(tagSetData);
                        self.tagSets.addOrReplace(tagSet);
                    }
                }

                if (newModelEnvironment.exposureProfiles) {
                    for (let item of newModelEnvironment.exposureProfiles) {                    
                        self.exposureProfiles.addOrReplace(item);
                    }
                }

                if (newModelEnvironment.propertyDefinitions) {
                    for (let propDefData of newModelEnvironment.propertyDefinitions) {                    
                        var propDef = new InvData.PropertyDefinition(propDefData);
                        self.propertyDefinitions.addOrReplace(propDef);
                    }
                }


                if (newModelEnvironment.entities) {
                    for (let newEntity of newModelEnvironment.entities) {                    
                        self._addEntity(newEntity);
                    }
                }

                if (newModelEnvironment.investments) {
                    for (let newInvestment of newModelEnvironment.investments) {                    
                        self._addInvestment(newInvestment);
                    }
                }

                if(newModelEnvironment.users){
                    for(let userData of newModelEnvironment.users){
                        var user = new InvData.User(userData);
                        self.users.addOrReplace(user);
                    }
                }

                if (newModelEnvironment.managers) {
                  for (let newManager of newModelEnvironment.managers) {
                    self._addManager(newManager);
                  }
                }
            }
        }


        public _addEntity(newEntity) {
            if (!this.entityIdToEntityMap[newEntity.id]) {
                // New entity, so add it to our list.
                this.entityIdToEntityMap[newEntity.id] = newEntity;

                if (newEntity.resourceId)
                    this.resourceIdToResourceMap[newEntity.resourceId] = newEntity;

                this.entityList.push(newEntity);
            }
        }

        public _addManager(newManager) {
          if (!this.managerIdToManagerMap[newManager.id]) {
            // New manager, so add it to our list.
            this.managerIdToManagerMap[newManager.id] = newManager;

            if (newManager.resourceId)
              this.resourceIdToResourceMap[newManager.resourceId] = newManager;

            this.managers.push(newManager);
          }
        }

        public _addInvestment(newInvestment) {
            if (!this.investmentIdToInvestmentMap[newInvestment.id]) {
                // New investment, so add it to our list.
                this.investmentIdToInvestmentMap[newInvestment.id] = newInvestment;

                if (newInvestment.resourceId)
                    this.resourceIdToResourceMap[newInvestment.resourceId] = newInvestment;

                this.investmentList.push(newInvestment);

                // Add investment id to the investment lookup lists.
                if (newInvestment.ownerId) {
                    if (this.ownerIdToInvestmentLookup[newInvestment.ownerId]) {
                        this.ownerIdToInvestmentLookup[newInvestment.ownerId].push(newInvestment.id);
                    }
                    else {
                        this.ownerIdToInvestmentLookup[newInvestment.ownerId] = [newInvestment.id];
                    }
                }

                if (newInvestment.holdingId) {
                    if (this.holdingIdToInvestmentLookup[newInvestment.holdingId]) {
                        this.holdingIdToInvestmentLookup[newInvestment.holdingId].push(newInvestment.id);
                    }
                    else {
                        this.holdingIdToInvestmentLookup[newInvestment.holdingId] = [newInvestment.id];
                    }
                }
            }
        }

    }

}

   

    




